export const CMP_CDID = "76286";
// CMP purpose id representing the "analytics" consent category. GTM is
// always-on in CMP so we no longer look at a specific vendor - we rely on
// whether the user accepted analytics tracking in general (purpose c4).
export const analyticsPurposeId = "c4";
export const CMP_HEALTH_TIMEOUT_MS = 5_000;
